// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vyKDF","title":"styles_title__E-Sfi","text":"styles_text__nxAw7"};